import { getElementById } from "../services/dom";
import footerTemplate from "../templates/sections/footer.html?raw";
import version from "../../package.json";

export default class Footer extends HTMLElement {
  constructor() {
    super();

    const container = getElementById("section-footer");
    container.classList.add("mx-auto", "px-2");
    container.innerHTML = footerTemplate;

    getElementById("footer-version").innerText = version.version;
  }
}

customElements.define("bottom-footer", Footer);
